'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useCallback } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { SectionHeader } from '@/components/ui/SectionHeader';
import { TestimonialBox } from '@/components/common/TestimonialBox';
import { cn } from '@/hooks/utils';
import { ArrowLeftIcon, ArrowRightIcon } from '@/components/ui/Icons';
interface TestimonialsProps {
  sectionTitle?: string;
  sectionSubtitle?: string;
  items?: Array<{
    quote: string;
    author: string;
    role: string;
    company: string;
    image?: string;
    logo?: string;
    imageClassName?: string;
    imageWrapperClassName?: string;
  }>;
}
export function Testimonials(t0) {
  const $ = _c(46);
  const {
    sectionTitle,
    sectionSubtitle,
    items
  } = t0;
  const resolvedItems = items;
  const resolvedTitle = sectionTitle;
  const resolvedSubtitle = sectionSubtitle;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      align: "start",
      loop: false,
      skipSnaps: false,
      slidesToScroll: 1,
      containScroll: "trimSnaps"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t1);
  const [canScrollPrev, setCanScrollPrev] = React.useState(false);
  const [canScrollNext, setCanScrollNext] = React.useState(false);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = emblaApi_0 => {
      setCanScrollPrev(emblaApi_0.canScrollPrev());
      setCanScrollNext(emblaApi_0.canScrollNext());
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const onSelect = t2;
  let t3;
  let t4;
  if ($[2] !== emblaApi) {
    t3 = () => {
      if (!emblaApi) {
        return;
      }
      onSelect(emblaApi);
      emblaApi.on("select", onSelect);
      emblaApi.on("reInit", onSelect);
    };
    t4 = [emblaApi, onSelect];
    $[2] = emblaApi;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  React.useEffect(t3, t4);
  let t5;
  if ($[5] !== emblaApi) {
    t5 = () => {
      if (emblaApi) {
        emblaApi.scrollPrev();
      }
    };
    $[5] = emblaApi;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const scrollPrev = t5;
  let t6;
  if ($[7] !== emblaApi) {
    t6 = () => {
      if (emblaApi) {
        emblaApi.scrollNext();
      }
    };
    $[7] = emblaApi;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const scrollNext = t6;
  let t7;
  if ($[9] !== resolvedSubtitle || $[10] !== resolvedTitle) {
    t7 = <SectionHeader title={resolvedTitle} subtitle={resolvedSubtitle} align="left" />;
    $[9] = resolvedSubtitle;
    $[10] = resolvedTitle;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = !canScrollPrev;
  const t9 = !canScrollPrev && "opacity-30 pointer-events-none";
  let t10;
  if ($[12] !== t9) {
    t10 = cn("cursor-pointer flex h-10 w-10 sm:h-14 sm:w-14 items-center justify-center rounded-full border border-[#E0E0E0] bg-white transition-opacity", t9);
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="sr-only">Previous</span>;
    t12 = <ArrowLeftIcon className="w-6 h-6 text-[#0B0623]" />;
    $[14] = t11;
    $[15] = t12;
  } else {
    t11 = $[14];
    t12 = $[15];
  }
  let t13;
  if ($[16] !== scrollPrev || $[17] !== t10 || $[18] !== t8) {
    t13 = <button onClick={scrollPrev} disabled={t8} className={t10}>{t11}{t12}</button>;
    $[16] = scrollPrev;
    $[17] = t10;
    $[18] = t8;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  const t14 = !canScrollNext;
  const t15 = !canScrollNext && "opacity-30 pointer-events-none";
  let t16;
  if ($[20] !== t15) {
    t16 = cn("cursor-pointer flex h-10 w-10 sm:h-14 sm:w-14 items-center justify-center rounded-full border border-[#E0E0E0] bg-white transition-opacity", t15);
    $[20] = t15;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  let t18;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <span className="sr-only">Next</span>;
    t18 = <ArrowRightIcon className="w-6 h-6 text-[#0B0623]" />;
    $[22] = t17;
    $[23] = t18;
  } else {
    t17 = $[22];
    t18 = $[23];
  }
  let t19;
  if ($[24] !== scrollNext || $[25] !== t14 || $[26] !== t16) {
    t19 = <button onClick={scrollNext} disabled={t14} className={t16}>{t17}{t18}</button>;
    $[24] = scrollNext;
    $[25] = t14;
    $[26] = t16;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] !== t13 || $[29] !== t19) {
    t20 = <div className="flex gap-3">{t13}{t19}</div>;
    $[28] = t13;
    $[29] = t19;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] !== t20 || $[32] !== t7) {
    t21 = <div className="container mx-auto px-6 lg:px-0"><div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">{t7}{t20}</div></div>;
    $[31] = t20;
    $[32] = t7;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  let t22;
  if ($[34] !== resolvedItems) {
    t22 = resolvedItems ?? [];
    $[34] = resolvedItems;
    $[35] = t22;
  } else {
    t22 = $[35];
  }
  let t23;
  if ($[36] !== t22) {
    t23 = t22.map(_temp);
    $[36] = t22;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  let t24;
  if ($[38] !== t23) {
    t24 = <div className="flex gap-2 px-6 lg:px-[calc(max(0px,(100vw-1240px)/2))]">{t23}</div>;
    $[38] = t23;
    $[39] = t24;
  } else {
    t24 = $[39];
  }
  let t25;
  if ($[40] !== emblaRef || $[41] !== t24) {
    t25 = <div className="relative"><div className="overflow-hidden w-full py-12 " ref={emblaRef}>{t24}</div></div>;
    $[40] = emblaRef;
    $[41] = t24;
    $[42] = t25;
  } else {
    t25 = $[42];
  }
  let t26;
  if ($[43] !== t21 || $[44] !== t25) {
    t26 = <section className="w-full bg-[#f8f7fa]" data-theme="light">{t21}{t25}</section>;
    $[43] = t21;
    $[44] = t25;
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  return t26;
}
function _temp(item, index) {
  return <div key={index} className="min-w-0 flex-[0_0_88%] md:flex-[0_0_512px]"><TestimonialBox quote={item.quote} author={item.author} role={item.role} company={item.company} image={item.image} logo={item.logo} imageClassName={item.imageClassName} imageWrapperClassName={item.imageWrapperClassName} className="min-h-[320px] sm:min-h-[560px]" /></div>;
}